import { createContext } from "react";
import { MAC_DOWNLOAD, WIN_DOWNLOAD } from '@/config/constent';

export type ContextValue = {
  userInfo: any;
  mac_plugin_latest_url: string;
  win_plugin_latest_url: string;
  setContextValue: (newData: any) => void;
};

export const defaultContextValue: ContextValue = {
  userInfo: null,
  mac_plugin_latest_url: MAC_DOWNLOAD,
  win_plugin_latest_url: WIN_DOWNLOAD,
  setContextValue: () => {},
};

export const DataContext = createContext(defaultContextValue);
